import React from "react";
import { Route, Routes } from "react-router-dom";
import BrowseJobs from "../components/BrowseJobs";
import EditForm from "../components/EditForm";
import JobsMap from "../components/JobsMap";
import NotFound from "../components/NotFound";
import AppChoices from "../components/admin/AppChoices";
import Counties from "../components/admin/Counties";
import Users from "../components/admin/Users";
import Auth from "../components/auth";
import Profile from "../components/profile";
import Schedule from "../components/scheduler/Schedule";
import { tabs } from "../helpers/constants";
import useAppChoices from "../hooks/useAppChoices";
import ProtectedRouteLayout from "../layouts/ProtectedRouteLayout";
import PublicRouteLayout from "../layouts/PublicRouteLayout";
import Agreement from "../pages/agreement";
import Inquire from "../pages/inquire";
import RequestService from "../pages/service_request";
import AdminRoute from "./AdminRoute";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import BrowseUserTimeLogs from "../components/time-tracker/BrowseUserTimeLogs";

const AppRoutes = () => {
  const appChoices = useAppChoices();

  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicRoute />}>
        <Route element={<PublicRouteLayout minifiedVersion />}>
          <Route
            path="/"
            element={<RequestService appChoices={appChoices} />}
          />
        </Route>{" "}
      </Route>
      <Route element={<PublicRouteLayout />}>
        <Route path="/inquire" element={<Inquire />} />
        <Route path="/inquire/:token" element={<Inquire />} />
      </Route>
      <Route element={<PublicRoute />}>
        <Route element={<PublicRouteLayout />}>
          <Route path="/agreement/:uuid" element={<Agreement />} />
          <Route path="/login" element={<Auth />} />
        </Route>
      </Route>
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<ProtectedRouteLayout />}>
          {" "}
          <Route path="/time-tracker" element={<BrowseUserTimeLogs />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/schedule/*" element={<Schedule />} />
          <Route path="/jobs">
            <Route path="map" element={<JobsMap />} />
            <Route
              path="browse"
              element={<BrowseJobs appChoices={appChoices} />}
            />
            {tabs.slice(1, tabs.length).map((tab, index) => {
              return (
                <Route
                  path={`${tab.path}`}
                  key={index}
                  element={
                    <BrowseJobs status={tab.name} appChoices={appChoices} />
                  }
                ></Route>
              );
            })}
          </Route>
          <Route
            path="/job/:id"
            element={<EditForm appChoices={appChoices} />}
          />
          <Route element={<AdminRoute />}>
            <Route path="/admin">
              <Route path="users" element={<Users />} />

              <Route
                path="app-choices"
                element={<AppChoices appChoices={appChoices} />}
              />
              <Route
                path="counties"
                element={<Counties appChoices={appChoices} />}
              />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<PublicRouteLayout headerVisible={false} />}>
          <Route
            path="/agreement/preview/:uuid"
            element={<Agreement preview />}
          />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
